<template>
  <v-row>
    <v-col class="fw-bold">{{i18n.global.t('pages.firmwareBulkUpdate.versionNote.name')}}</v-col>
  </v-row>
  <v-row>
    <v-col>
      <v-textarea
        bg-color="grey-lighten-2"
        rows="3"
        readonly
        :value="props.note"
      ></v-textarea>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import i18n from '@/lang/i18n';

const props = defineProps<{
  note: string | undefined
}>()
</script>
